import { NavLink } from "react-router-dom";
const NavBar = () => {
  return (
    <div className="w-full flex flex-row justify-between text-xs xl:text-xl py-10 z-10">
      <h1>Leading the digital world since 2023</h1>
      <ul className="flex flex-row">
        {[
          ["Home", "/"],
          ["Projects", "/Projects"],
          // ["Services", "/Services"],
          ["Team", "/Team"],
        ].map(([title, url]) => {
          return (
            <li
              key={title}
              className="flex flex-row justify-center items-center"
            >
              <NavLink
                to={url}
                className={({ isActive }) => {
                  return isActive ? "text-accent px-2" : "px-2";
                }}
              >
                {title}
              </NavLink>
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export default NavBar;
